export const favorites = {
    state: {
        products: [],
        loaded: false
    },
    mutations: {
        setFavorites(context, products) {
            context.products = products
        },
        setLoaded(context, bool) {
          context.loaded = bool;
        },
        removeFavorite(context, productId) {
            var index = context.products.indexOf(productId);
            if (index !== -1) context.products.splice(index, 1);
        },
        addFavorite(context, productId) {
            context.products.push(productId);
        }
    },
    getters: {
        isLoaded: state => {
            return state.loaded;
        }
    },
    actions: {
        loadFavorites(context) {
           if(!context.getters.isLoaded) {
               context.commit('setLoaded', true);
               return new Promise((resolve, reject) => {
                   axios.get('/api/site/favorites/')
                       .then(response => {
                           context.commit('setFavorites', response.data);
                       })
                       .catch(error => {
                           context.commit('setLoaded', false);
                           reject(error);
                       });
               });
           }
        },
        toggleFavorite(context, payload) {
            if (payload.destroy) {
                return new Promise((resolve, reject) => {
                    axios.delete('/api/site/favorites/destroy/', {
                        data: {
                            'product_id': payload.product_id
                        }
                    })
                    .then(response => {
                        context.commit('removeFavorite', payload.product_id);
                    })
                    .catch(error => {
                        reject(error);
                    });
                });
            } else {
                return new Promise((resolve, reject) => {
                    axios.post('/api/site/favorites/store/', {
                        'product_id': payload.product_id
                    })
                    .then(response => {
                        context.commit('addFavorite', payload.product_id);
                    })
                    .catch(error => {
                        reject(error);
                    });
                });
            }
        }
    }
}
